import React from "react";
import theme from "app/Theme/Theme";
import Svg, {
  Circle,
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  Stop,
} from "react-native-svg";
import normalize from "app/utils/normalize";

const OtherNotification = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.white"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Circle cx={12} cy={12} r={12} fill="#007EFC" />
    <Circle cx={12} cy={12} r={12} fill="url(#OtherNotification1)" />
    <G clipPath="url(#b)" fill={color}>
      <Path d="M8.23 12.911a.845.845 0 0 1-.255-.62c0-.242.085-.448.255-.619a.84.84 0 0 1 .617-.255.84.84 0 0 1 .618.255c.17.17.255.377.255.62a.845.845 0 0 1-.255.62.84.84 0 0 1-.618.255.84.84 0 0 1-.617-.256ZM11.15 12.911a.845.845 0 0 1-.256-.62c0-.242.085-.448.255-.619a.84.84 0 0 1 .618-.255.84.84 0 0 1 .617.255c.17.17.255.377.255.62a.845.845 0 0 1-.255.62.84.84 0 0 1-.617.255.84.84 0 0 1-.618-.256ZM14.068 12.911a.845.845 0 0 1-.255-.62c0-.242.085-.448.255-.619a.84.84 0 0 1 .618-.255.84.84 0 0 1 .617.255c.17.17.255.377.255.62a.845.845 0 0 1-.255.62.84.84 0 0 1-.617.255.84.84 0 0 1-.618-.256Z" />
    </G>
    <Defs>
      <LinearGradient
        id="OtherNotification1"
        x1={12}
        y1={0}
        x2={12}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#6493AA" />
        <Stop offset="1" stopColor="#5C7391" />
      </LinearGradient>
      <ClipPath id="b">
        <Path fill={color} transform="translate(5 5)" d="M0 0h14v14H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default OtherNotification;
